// Settings → Fields (global, across all routes).

import { Btn } from "../components/Primitives";
import { RouteFields } from "./RouteDetail";

interface Props { onEdit: (id: string) => void; }

export function FieldsScreen({ onEdit }: Props) {
  return (
    <div className="page">
      <div className="topbar">
        <span className="crumb">Settings</span>
        <span className="crumb-sep">/</span>
        <h1>Fields</h1>
        <span className="grow" />
        <Btn size="sm" ico="plus" kind="primary" onClick={() => onEdit("new")}>
          New field
        </Btn>
      </div>
      <div className="scroll" style={{ padding: "22px 28px 60px" }}>
        <p style={{
          color: "var(--ink-2)", fontSize: 13,
          maxWidth: 540, margin: "0 0 22px",
        }}>
          Fields are what Prism extracts from every inbound email. A clear
          description is the single most important input — it's what the model
          uses to decide.
        </p>
        <RouteFields onEdit={onEdit} />
      </div>
    </div>
  );
}
